import TableRatesData from "./components/tableRatesData";

const Rates = () => {
  return (
    <TableRatesData />
  )
};

export default Rates;